<main class="bg-off-white rounded-12px p-24px">
	<div>
		<app-countries-tabs
			(countryId)="countryId = $event; urlParamsChange($event, 'countryId')"
			[selectedCountry]="reviewFilter.countryId"
		></app-countries-tabs>
	</div>
	<div class="my-[18px] overflow-auto">
		<app-tabs
			[taps]="reviewTabs"
			[activeTap]="reviewFilter.activeTab || 1"
			(tapChanged)="urlParamsChange($event, 'activeTab')"
		></app-tabs>
	</div>
	<app-reviews-table
		*ngIf="reviews?.length"
		[reviews]="reviews"
		[reviewFilter]="reviewFilter"
		[totalCount]="totalCount"
		(changeStatus)="changeStatus($event)"
		[countryId]="reviewFilter.countryId"
	></app-reviews-table>
	<app-no-data-found *ngIf="!reviews?.length"></app-no-data-found>
	<!-- pagination -->
	<div class="py-5 max-mobile:overflow-auto">
		<app-pagination
			[totalCount]="totalCount"
			[pageNumber]="reviewFilter.paging.pageNumber"
			[pageCount]="reviewFilter.paging.pageSize"
			(currentPage)="pageChanged($event, reviewFilter.paging.pageSize)"
			(itemsCountPerPage)="pageChanged(1, $event)"
		></app-pagination>
	</div>
</main>
